import { useCallback, useRef } from 'react'
import { useLocation } from 'react-router'

const findCanonicalLink = (): HTMLLinkElement | null => {
  return document.querySelector("link[rel='canonical']")
}
const findOrCreateCanonicalLink = (): HTMLLinkElement => {
  let link = findCanonicalLink()
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  return link
}

const useCanonicalLink = () => {
  const location = useLocation()
  // Track the latest location in a ref so `set`/`clear` keep a stable identity
  // across navigations while still reading the current pathname/search.
  const locationRef = useRef(location)
  locationRef.current = location

  const set = useCallback((withParams?: string[]) => {
    const link = findOrCreateCanonicalLink()
    const { pathname, search } = locationRef.current
    const qp = new URLSearchParams(search)
    const canonicalParams = withParams?.reduce((params, param) => {
      const value = qp.get(param)
      if (value) {
        params.set(param, value)
      }
      return params
    }, new URLSearchParams())
    const url = `${window.location.origin}${pathname}${canonicalParams?.toString() ? `?${canonicalParams.toString()}` : ''}`
    link.setAttribute('href', url)
  }, [])
  const clear = useCallback(() => {
    const link = findCanonicalLink()
    if (link) {
      link.parentNode?.removeChild(link)
    }
  }, [])
  return { set, clear }
}

export default useCanonicalLink
